import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName
} from "../../../utility/index"
import moment from "moment";
export default {
    name: "TerminalFile",
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            formInline: {
                numberType: '',
                number: '',
                externalType: '',
                simIccicd: '',
                deliveryTime: ''
            },
            optionsInput: [{
                value: '',
                label: this.$t('ExternalEqu.all')
            }, {
                value: '0',
                label: this.$t('ExternalEqu.externalId')
            }, {
                value: '1',
                label: this.$t('ExternalEqu.carId')
            }, {
                value: '2',
                label: this.$t('ExternalEqu.terminalId')
            }, {
                value: '3',
                label: this.$t('ExternalEqu.equIMEINumber')
            }],
            typeList: [{
                id: '',
                name: this.$t('ExternalEqu.all')
            }],
            typeList: [],
            height: '550',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                    prop: "externalId",
                    label: this.$t('ExternalEqu.externalId'),
                    align: "center",
                    width: "260px"
                },
                {
                    prop: "imei",
                    label: this.$t('ExternalEqu.equIMEINumber'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "simIccicd",
                    label: this.$t('TerminalFile.simIccicd'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "deliveryTime",
                    label: this.$t('TerminalFile.deliveryTime'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "externalTypeStr",
                    label: this.$t('ExternalEqu.externalTypeStr'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carId",
                    label: this.$t('ExternalEqu.carId'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('ExternalEqu.terminalId'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "remarks",
                    label: this.$t('ExternalEqu.remarks'),
                    align: "center",
                    width: "240px"
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '110px',
            diaTitle: '',
            btnType: '',
            rules: {
                externalId: [{
                    required: true,
                    message: this.$t('ExternalEqu.form.terminalId'),
                    trigger: 'blur'
                }],
            },
            form: {
                externalId: '',
                IMEI: '',
                externalType: '',
                simIccicd: '',
                deliveryTime: '',
                remarks: '',
            },
            disabled: false,
            dialogTransferFormVisible: false,
            LabelWidth: '104px',
            TransferRules: {},
            TransferForm: {
                externalId: '',
                carId: ''
            },
            selected: [],
            id: '',
            name: '',
            dialogBatchFormVisible: false,
            isShow: true,
        }
    },
    created() {
        this.getTerminalType()
        this.getAllTerminal()
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        getAllTerminal() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.deliveryTime) {
                if (this.formInline.deliveryTime.length > 0) {
                    startTime = this.formInline.deliveryTime[0]
                    endTime = this.formInline.deliveryTime[1]
                }
            }
            let param = {
                numberType: this.formInline.numberType,
                number: this.formInline.number,
                externalType: this.formInline.externalType,
                simIccicd: this.formInline.simIccicd,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('ExternalEqu/GET_SELECTEXTERNAL', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => {})
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllTerminal()
        },
        onClear() {
            this.formInline = {
                numberType: '',
                number: '',
                externalType: '',
                simIccicd: '',
                deliveryTime: ''
            }
            this.getAllTerminal()
        },
        getTerminalType() {
            this.$store.dispatch('DictionaryManaged/GET_SELECTEXTERNALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.typeList = res.data.data
                    }
                }
            }).catch(err => {})
        },
        addTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.disabled = false
            this.$nextTick(() => {
                this.$refs.form.resetFields()
            })
        },
        editTerminal() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.disabled = true
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
            this.form.externalId = this.selected[0].externalId
            this.form.IMEI = this.selected[0].imei
            this.form.externalType = this.selected[0].externalType
            this.form.simIccicd = this.selected[0].simIccicd
            this.form.deliveryTime = this.selected[0].deliveryTime
            this.form.remarks = this.selected[0].remarks
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        externalId: this.form.externalId,
                        IMEI: this.form.IMEI,
                        externalType: this.form.externalType,
                        simIccicd: this.form.simIccicd,
                        deliveryTime: this.form.deliveryTime,
                        remarks: this.form.remarks,
                    }
                    if (this.btnType == 'add') {
                        this.$store.dispatch('ExternalEqu/GET_INSERTEXTERNAL', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => {})
                    } else {
                        this.$store.dispatch('ExternalEqu/GET_UPDATEEXTERNAL', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllTerminal();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => {})
                    }


                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                externalId: '',
                IMEI: '',
                externalType: '',
                simIccicd: '',
                deliveryTime: '',
                remarks: '',
            }
        },
        closeDia() {
            this.form = {
                externalId: '',
                IMEI: '',
                externalType: '',
                simIccicd: '',
                deliveryTime: '',
                remarks: '',
            }
            this.dialogFormVisible = false;
        },
       
        deleteTerminal() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    externalId: this.selected[0].externalId
                }
                this.$store.dispatch('ExternalEqu/GET_DELETEEXTERNAL', param).then(response => {
                    if (response.data.code == 200) {
                        this.getAllTerminal()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => {})
            }).catch(err => {

            })
        },

        transferTerminal() {
            this.dialogTransferFormVisible = true
            this.TransferForm.externalId = this.selected[0].externalId
            this.TransferForm.carId = this.selected[0].carId
            if (this.TransferForm.carId) {
                this.isShow = true
            } else {
                this.isShow = false
            }
        },
        submitTransferForm(TransferFormName) {
            this.$refs[TransferFormName].validate((valid) => {
                if (valid) {
                    let param = {
                        externalId: this.TransferForm.externalId,
                        carId: this.TransferForm.carId
                    }
                    this.$store.dispatch('ExternalEqu/GET_EXTERNALBINDINGCAR', param).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('common.btn.bindSuccess'))
                            this.dialogTransferFormVisible = false;
                            this.getAllTerminal();
                            this.closeTransfer();
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => {})
                } else {
                    return false;
                }
            });
        },
        cancleTransfer(TransferFormName) {
            this.dialogTransferFormVisible = false;
            this.TransferForm = {
                externalId: '',
                carId: ''
            }
        },
        closeTransferDia() {
            this.TransferForm = {
                externalId: '',
                carId: ''
            }
            this.dialogTransferFormVisible = false;
        },
        Relieve() {
            this.$confirm(this.$t('common.btn.bindText'), this.$t('common.btn.hint'), {
                cancelButtonText: this.$t('common.btn.cancel'),
                confirmButtonText: this.$t('common.btn.confirm'),
                type: 'warning'
            }).then(res => {
                let param = {
                    externalId: this.TransferForm.externalId,
                    carId: ''
                };
                this.$store.dispatch('ExternalEqu/GET_EXTERNALBINDINGCAR', param).then(response => {
                    if (response.data.code == 200) {
                        this.dialogTransferFormVisible = false;
                        this.getAllTerminal();
                        this.closeTransfer();
                        this.$message.success(this.$t('common.btn.unBindSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },
        downTerminal() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let startTime = ''
                    let endTime = ''
                    if (this.formInline.deliveryTime) {
                        if (this.formInline.deliveryTime.length > 0) {
                            startTime = this.formInline.deliveryTime[0]
                            endTime = this.formInline.deliveryTime[1]
                        }
                    }
                    let companyId = sessionStorage.getItem("companyId")
                    let url = `https://${domainName}/v1/getExportExcel/exportExternal?number=${this.formInline.number}&numberType=${this.formInline.numberType}&externalType=${this.formInline.externalType}&simIccicd=${this.formInline.simIccicd}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportExternal?number=${this.formInline.number}&numberType=${this.formInline.numberType}&externalType=${this.formInline.externalType}&simIccicd=${this.formInline.simIccicd}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllTerminal();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}